var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.navItemClassObject},[_c('a',{class:_vm.classObject,attrs:{"href":_vm.link}},[(_vm.icon)?_c('div',{class:_vm.navIconClassObject},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }